import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DetailsProps } from '../types';
import MeasuredTorpedo from '../../../Torpedo/MeasuredTorpedo';
import { Item as DeviationTorpedoItem } from '../../../Torpedo/DeviationTorpedo/DeviationTorpedo';
import { TorpedoProps } from '../../../Torpedo/Torpedo';
import { TorpedoLayoutedItem } from '../../../Torpedo/types';
import DeviationThumbView from '../../../DeviationViews/Thumb/Standard';
import MediaService from '../../../utils/DeviationMediaService';
import DefaultDetails from '../Default';

import s from './Originals.scss';

const thumbRenderer = (
  renderProps: TorpedoProps,
  item: TorpedoLayoutedItem<DeviationTorpedoItem>
) => {
  return (
    <DeviationThumbView
      className={s['thumb']}
      deviation={item.dto.deviation}
      width={item.width}
      height={item.height}
    />
  );
};

export const OriginalsDetails: React.FC<DetailsProps> = ({
  deviation,
  ...props
}) => {
  const { t } = useTranslation();
  const custom_exclusives = useFlag('custom_exclusives');
  const isDesktop = !useContext(MobileContext);
  const completedOrders = deviation.extended?.originals?.completedOrders ?? [];
  const completedOrdersCount =
    deviation.extended?.originals?.completedOrdersCount ?? 0;
  const torpedo =
    custom_exclusives && completedOrders.length > 0 ? (
      <>
        <div className={s['completed-orders-heading']}>
          {t('deviation.details.originals.completedOrders', {
            count: completedOrdersCount,
          })}
        </div>
        <MeasuredTorpedo
          container={{ width: 780 }}
          items={completedOrders.map(item => {
            const largest = MediaService.getThumbDimensions(item);
            return {
              id: `deviation-${item.deviationId}`,
              width: largest.width || 0,
              height: largest.height || 0,
              deviation: item,
            };
          })}
          renderItem={thumbRenderer}
          cookieDim="width"
          cookieType={MeasuredCookieType.DEVIATION_DESCRIPTION}
        />
      </>
    ) : null;

  return (
    <DefaultDetails
      deviation={deviation}
      {...props}
      bottomSlot={torpedo}
      showTitle={isDesktop}
      withDividerBelowStats={isDesktop}
      withGruserZone={false}
    />
  );
};
OriginalsDetails.displayName = 'OriginalsDetails';

export default OriginalsDetails;
